import React, { ComponentType, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@/App/hooks';
import { getAppConfigThunk } from '@/features/config/configSlice';
import { selectAppConfigInitialized } from '@/features/config/selectAppConfigInitialized';

interface WithConfigProps {}

export const withConfig = <T extends WithConfigProps>(WrappedComponent: ComponentType<T>) => {
  const HOC = (props: T) => {
    const dispatch = useAppDispatch();
    const appConfigInitialized = useSelector(selectAppConfigInitialized);

    useEffect(() => {
      if (!appConfigInitialized) {
        dispatch(getAppConfigThunk());
      }
    }, [dispatch, appConfigInitialized]);

    if (!appConfigInitialized) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };
  HOC.displayName = `withConfig(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return HOC;
};
